<template>
    <transition name="fade">
        <div v-if="show" class="preview-wrap" :class="{ display: show2 }">
            <div class="preview-mask" :style="{ opacity: percentage }"></div>
            <div
                class="row center v-center inline-active"
                @click="close"
                style="cursor:pointer; z-index: 5002; position:fixed; top:32px; right:32px; width:48px; height:48px; border-radius:50%; background:rgba(38,38,38,.75); color:rgba(255,255,255,.9);"
            >
                <div class="icon-44 inline-active">
                    <i class="iconfont icon-close"></i>
                </div>
            </div>
            <div
                class="preview"
                ref="preview"
                v-hammer:panstart="onPanStart"
                v-hammer:pan="onPanMove"
                v-hammer:panend="onPanEnd"
                :class="{ animation: animate }"
                :style="{ transform: transform }"
            >
                <!-- Swiper -->
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in urls" :key="index">
                            <div class="swiper-zoom-container">
                                <img :data-src="item" class="swiper-lazy" />
                                <div
                                    class="swiper-lazy-preloader swiper-lazy-preloader-white"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <!-- <div
                        class="swiper-pagination swiper-pagination-white"
                        v-show="urls.length > 1"
                    ></div> -->
                </div>
                <div
                    class="row px-lg py-lg center v-center white t5"
                    style="position:absolute; bottom:0; right:0; left:0; z-index:9999;"
                >
                    {{ displayIndex }} / {{ urls.length }}
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

export default {
    data() {
        return {
            swiper: null,

            show: false,
            show2: false,

            current: '',
            urls: [],

            currentItem: 0,

            moveX: 0,
            moveY: 0,
            direction: null,
            movePercentage: 0,
            animate: true,
            height: 0,
        };
    },

    computed: {
        transform() {
            const toPercent = (point) => {
                let str = Number(point * 100);
                str += '%';
                return str;
            };
            const yyoo = toPercent(this.movePercentage);
            const xxoo = `translate(0, ${yyoo})`;
            return xxoo;
        },

        percentage() {
            const toPercent = (point) => {
                let str = Number(point * 100);
                str += '%';
                return str;
            };
            const yyoo = toPercent(1 - this.movePercentage);
            return yyoo;
        },

        displayIndex() {
            return +this.currentItem + 1;
        },
    },

    watch: {
        show() {
            // console.log('~~~~~>>>>> watch:');
            this.currentItem = this.urls.indexOf(this.current);
            // console.log('~~~~~>>>>> watch: this.currentItem', this.currentItem);

            this.$nextTick(function () {
                this.swiper = new Swiper('.preview .swiper-container', {
                    lazy: true,
                    zoom: true,
                    threshold: 10,

                    initialSlide: +this.currentItem,
                    observer: true,
                    observeParents: false,

                    pagination: {
                        el: '.swiper-pagination',
                    },
                });

                if (this.swiper) {
                    this.swiper.on(
                        'slideChange',
                        () => {
                            // console.log('slide changed');
                            this.currentItem = this.swiper.activeIndex;
                        },
                    );
                }
            });
        },
    },

    methods: {
        close() {
            this.show = false;
            this.show2 = false;
        },

        //------------------------------------------------------------
        onPanStart(e) {
            console.log('onPanStart', e);

            this.height = this.$refs.preview.clientHeight;
        },

        onPanMove(e) {
            // console.log('......... onPanMove');
            if (this.animate) {
                this.animate = false;
            }

            this.moveX = e.deltaX;
            this.moveY = e.deltaY > 0 ? e.deltaY : 0;

            this.movePercentage = this.moveY / this.height;

            if (Math.abs(this.moveY) < Math.abs(this.moveX)) {
                this.direction = 'X';
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
            } else {
                this.direction = 'Y';
            }
        },
        onPanEnd(e) {
            // console.log('onPanEnd', e);

            if (this.direction !== 'Y') {
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
                return;
            }

            this.animate = true;

            if (this.moveY >= 112) {
                this.moveY = this.height;
                this.movePercentage = this.moveY / this.height;
                this.close();
            } else {
                this.moveY = 0;
                this.movePercentage = this.moveY / this.height;
            }
        },
        //------------------------------------------------------------
    },
};
</script>

<style lang="scss" scoped>
.preview-wrap {
    &.display {
        .preview-mask {
            opacity: 1;
        }
    }
}

.preview-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5000;
    background: rgba(0, 0, 0, 0.95);
    opacity: 0;
    will-change: transform;
    transition: all 0.3s;
}
.preview {
    z-index: 5001;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.swiper-container {
    width: 100%;
    height: 100%;
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    // background: #000;
}
.swiper-slide img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}

.animation {
    transition: transform ease 0.3s;
}
.preview.animation:before {
    content: '';
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
}
</style>
